
import React, { useEffect, useState } from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';

import { DRUH_POZEMKU } from '../../common/iskn/druhPozemku';

const classNames = mergeStyleSets({
    root: {
    }
});

const DruPozComboBox = (props) => {

    const [value, setValue] = useState(props.value);

    useEffect(() => {
        if (props.onChange) {
            props.onChange(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleChangeItem = (event, option) => {
        setValue(option.key);
    }

    const getOptions = () => {
        let options = [];

        if (props.all) {
            options.push({key: '', text: '<<vše>>'});
        }

        options = [
            ...options,
            ...DRUH_POZEMKU.map(item => {
                return {
                    key: item.code,
                    text: item.title
                };
            })
        ];

        if (!value && !props.all) {
            if (options.length > 0) {
                setValue(options[0].key);
            }
        }

        return options;
    }

    return (
        <div className={classNames.root}>
            <ComboBox
                label="Druh pozemku"
                options={getOptions()}
                selectedKey={value}
                onChange={handleChangeItem}
            />
        </div>
    );
}

export default DruPozComboBox;
